import type { IConfRelacionesEntidades } from '@/modules/Configuracion/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'

export class EntidadRelacionadosService extends BaseService<IConfRelacionesEntidades> {
  constructor () {
    super({
      baseUrl: 'system/entities-related/'
    })
  }

}
